const TAXATION_TYPES = {
    OSN: 'osn',
    USN_INCOME: 'usn_income',
    USN_INCOME_OUTCOME: 'usn_income_outcome',
    PATENT: 'patent',
    ENVD: 'envd',
    ESN: 'esn'
};

const RU_TAXATION_TYPES = {
  [TAXATION_TYPES.OSN]: 'osn - Основная система налогообложения',
  [TAXATION_TYPES.USN_INCOME]: 'usn_income - Упрощённая система налогообложения (по доходам)',
  [TAXATION_TYPES.USN_INCOME_OUTCOME]: 'usn_income_outcome - Упрощённая система налогообложения (доходы минус расходы)',
  [TAXATION_TYPES.PATENT]: 'patent - Патентная система налогообложения',
  [TAXATION_TYPES.ENVD]: 'envd - Единый налог на вменённый доход (ЕНВД)',
  [TAXATION_TYPES.ESN]: 'esn - Единый сельскохозяйственный налог (ЕСХН)'
};

const EN_TAXATION_TYPES = {
  [TAXATION_TYPES.OSN]: 'osn - Basic tax system',
  [TAXATION_TYPES.USN_INCOME]: 'usn_income - Simplified taxation system (by income)',
  [TAXATION_TYPES.USN_INCOME_OUTCOME]: 'usn_income_outcome - Simplified tax system (income minus expenses)',
  [TAXATION_TYPES.PATENT]: 'patent - Patent taxation system',
  [TAXATION_TYPES.ENVD]: 'envd - Single tax on imputed income (UTII)',
  [TAXATION_TYPES.ESN]: 'esn - Unified agricultural tax (UAT)'
};

const TAXATION_LANG_ADAPTER = {
  ru: RU_TAXATION_TYPES,
  en: EN_TAXATION_TYPES
};

module.exports = {
  TAXATION_LANG_ADAPTER
}